'use client';

import { cn } from '@ngg/storefront-utils';
import { MouseEvent, ReactNode } from 'react';

export default function HeaderReadMore({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    document
      .querySelector('.page-footer')
      ?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={cn('text-base underline hover:no-underline', className)}>
      {children}
    </button>
  );
}
